import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import noMessagesGraphic from '../../../assets/images/no-messages-graphic.svg';

function NoDataMessage(): React.ReactElement {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        textAlign: 'center',
        maxWidth: '25rem',
        width: '100%',
        my: 4
      }}
    >
      <Typography
        variant='h2'
        sx={{ mb: 2, fontSize: isMobile ? '1.2rem' : '1.6rem' }}
      >
        Your chatbot isn&apos;t built yet
      </Typography>
      <Typography sx={{ fontSize: '1rem' }}>
        Once you build your chatbot, you&apos;ll start seeing analytics here.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <Box
          component='img'
          role='presentation'
          src={noMessagesGraphic}
          sx={{
            height: '12rem',
            marginY: 4,
            '@media screen and (max-width: 500px)': {
              height: '8rem'
            },
            '@media screen and (max-height: 750px)': {
              display: 'none'
            }
          }}
        />
      </Box>
    </Box>
  );
}

export default NoDataMessage;
